module.exports = __webpack_public_path__ + "img/scenes_13.c5d576c1.png";